function removeAllRegisterFormErrorAlert() {
  const prevEls = document.querySelectorAll(".register-form-error-alert");
  prevEls.forEach((prevEl) => {
    if (prevEl) prevEl.remove();
  });
}

function showRegisterFormErrorAlert(errors) {
  removeAllRegisterFormErrorAlert();

  const alert = document.createElement("div");
  alert.classList.add("register-form-error-alert");

  let html = "ERROR: <br/>";

  for (const [key, value] of Object.entries(errors)) {
    // Convert snake_case to "Title Case"
    const formattedKey = key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    html += `<strong style="color: #ffffff; font-size: 13px;">${formattedKey}</strong>: ${value}<br/>`;
  }

  alert.innerHTML = html;

  const closeIcon = document.createElement("div");
  closeIcon.classList.add("close-icon");
  closeIcon.innerHTML =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.00003 3.58569L20.4142 18.9999L19 20.4141L3.58582 4.99991L5.00003 3.58569Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4142 4.99991L5.00003 20.4141L3.58582 18.9999L19 3.58569L20.4142 4.99991Z" fill="currentColor"/></svg>';
  closeIcon.addEventListener("click", () => {
    removeAllRegisterFormErrorAlert();
  });
  alert.appendChild(closeIcon);

  document.body.appendChild(alert);

  // ⏳ Remove after 3 seconds (3000 ms)
  setTimeout(() => {
    // alert.remove();
  }, 5000);
}

// Intercept fetch responses
const originalFetch = window.fetch;

window.fetch = async function (resource, config) {
  if (resource.includes("form_submission")) {
    removeAllRegisterFormErrorAlert();

    // console.log(resource);
    // console.log(config);
    // console.log(JSON.parse(config.body));
    const newBody = JSON.parse(config.body);
    newBody["custom#phone_number"] = newBody["phone_number"];
    delete newBody["phone_number"];

    config.body = JSON.stringify(newBody);
  }

  const response = await originalFetch(resource, config);

  // Clone the response so we can read it
  const clonedResponse = response.clone();

  clonedResponse.text().then((response) => {
    if (resource.includes("form_submission")) {
      const data = JSON.parse(response);
      // console.log('🔍 [FETCH] URL:', resource);
      //   console.log(data);
      if (Object.keys(data.errors).length > 0) {
        // console.log("❌ There are errors:", data.errors);
        showRegisterFormErrorAlert(data.errors);
      } else {
        // console.log("✅ No errors!");
      }
    }
  });

  return response;
};
